module.exports = require("request-promise");


//////////////////
// WEBPACK FOOTER
// external "request-promise"
// module id = 10
// module chunks = 0